module.exports = __webpack_public_path__ + "img/loading2.32902bf5.png";